<template>
  <div>
    <!-- The dynamic list title that comes in as a prop -->
    <div class="majorTitle">
      {{ listTitle }}
    </div>

    <!-- Loop through the lists of grouped items -->
    <div
      v-for="group in groupedItems"
      :key="group.title"
      class="marginLargeBottom"
    >
      <!-- The title for this group of items -->
      <div class="minorTitle">
        {{ group.title }}
      </div>

      <!-- The list of items -->
      <ul v-if="group.items.length > 0">
        <!-- Loop through the items -->
        <li
          v-for="item in group.items"
          :id="'item-card-' + item.inventory_id"
          :key="item.inventory_id"
          class="itemRow"
        >
          <ItemCard :item_id="item.inventory_id" />
        </li>
      </ul>

      <!-- There are no items in this list -->
      <div
        v-else
        class="colorGrey textCenter"
      >
        No items.
      </div>
    </div>

    <!-- The interset observer that fires when it enters the viewport -->
    <Observer @intersect="onIntersect" />
  </div>
</template>

<script>
import ItemCard from '@/components/ItemCard'
import Observer from '@/components/Observer'

export default {

	name: 'ItemList',

	components: {
		ItemCard,
		Observer
	},

	props: [
		'listId',
		'listTitle',
		'groupBy'
	],

	data () {
		return {
			'page': 0,
			'offset': 50
		}
	},

	computed: {

		// this was formerly in mapState - can't use that due to Edge
		items: function () {
			return this.$store.state.items
		},

		// this was formerly in mapState - can't use that due to Edge
		biddingStatuses: function () {
			return this.$store.state.biddingStatuses
		},

		// this was formerly in mapState - can't use that due to Edge
		lists: function () {
			return this.$store.state.lists
		},

		// the items we are viewing right now
		groupedItems: function () {
			let tempItems = {}

			// we are grouping by selling and sold
			if (this.groupBy === 'sold_status') {
				tempItems.selling = {
					'title': 'Selling Now',
					'items': []
				}
				tempItems.sold = {
					'title': 'Sold',
					'items': []
				}
			}

			// the list exists in the store
			if (typeof (this.lists['LISTID_' + this.listId]) !== 'undefined') {
				// loop through all of the inventory ids on their bid list
				this.lists['LISTID_' + this.listId].inventory_ids.forEach((value) => {
					// the inventory id has a corresponding item and bidding_status in the store
					if (
						typeof (this.items['ITEMID_' + value]) !== 'undefined' &&
						typeof (this.biddingStatuses['ITEMID_' + value]) !== 'undefined'
					) {
						let tempItem = {
							'inventory_id': value,
							'target_url': this.items['ITEMID_' + value].card.target_url,
							'image': this.items['ITEMID_' + value].card.image,
							'title': this.items['ITEMID_' + value].card.title
						}

						// we are grouping by selling and sold
						if (this.groupBy === 'sold_status') {
							// this item has not sold
							if (this.biddingStatuses['ITEMID_' + value].has_sold === false) {
								tempItems.selling.items.push(tempItem)

							// this item has sold
							} else {
								tempItems.sold.items.push(tempItem)
							}
						}
					}
				})

				tempItems.sold.items = tempItems.sold.items.slice(0, ((this.page * this.offset) + this.offset))
				return tempItems
			} else {
				return tempItems
			}
		}
	},

	mounted () {},
	methods: {
		onIntersect () {
			this.page = this.page + 1
		}
	}
}

</script>

<style scoped>

</style>
